import { X, Database, Zap } from "lucide-react";

export default function ConfigurationModalHeader({
  service,
  integration,
  onClose
}) {
  return (
    <div className="bg-gradient-to-b from-blue-50/50 via-blue-50 to-blue-50/50 border-b border-gray-200 p-6">
      <div className="flex items-start justify-between">
        <div>
          <h2 className="text-xl font-bold text-gray-900 mb-1">
            {service.name}
          </h2>
          <p className="text-gray-500 text-sm mb-3">{service.description}</p>
          <div className="flex items-center gap-4 text-sm">
            <span className="flex items-center gap-1.5">
              <Database className="w-4 h-4 text-blue-600" />
              <span className="text-gray-600">
                Provider:{" "}
                <span className="font-semibold text-gray-900">
                  {integration.name}
                </span>
              </span>
            </span>
            <span className="flex items-center gap-1.5">
              <Zap className="w-4 h-4 text-orange-500" />
              <span className="text-gray-600">
                Endpoints:{" "}
                <span className="font-semibold text-gray-900">
                  {service.endpoints}
                </span>
              </span>
            </span>
          </div>
        </div>
        <button
          onClick={onClose}
          className="p-1.5 hover:bg-gray-200 rounded-lg transition-colors"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>
      </div>
    </div>
  );
}
